const active = ({ errorColorPalette }) => errorColorPalette[600];

export default active;
